import { useProgramDefinition, useProtocolDefinitions } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { CatalogDefinition, ProgramEdit } from "@/features/catalog";
import { programDefinitionUrlFromRouteId } from "@/features/catalog/lib/program-definition-route";

export const Route = createFileRoute("/catalog/procedures/$procedureId_/edit")({
  beforeLoad: ({ context }) => {
    const { permissions } = context;
    if (!permissions.canRead("PlanDefinition")) {
      throw redirect({ to: "/catalog/procedures" });
    }
  },
  component: EditCatalogItemComponent,
});

function EditCatalogItemComponent() {
  const { procedureId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();

  const programDefinition = useProgramDefinition(programDefinitionUrlFromRouteId(procedureId));

  const protocolDefinitions = useProtocolDefinitions();
  const canEdit = permissions.canWrite("PlanDefinition");

  const navigateBack = useCallback(
    () => navigate({ to: "/catalog/procedures/$procedureId", params: { procedureId } }),
    [navigate, procedureId],
  );

  if (!programDefinition) {
    return <CatalogDefinition.NotFound label="Item" backTo="/catalog/procedures" backLabel="Back to procedures" />;
  }

  return (
    <ProgramEdit
      key={procedureId}
      item={programDefinition}
      protocolItems={protocolDefinitions}
      canEdit={canEdit}
      onDone={navigateBack}
      onCancel={navigateBack}
    />
  );
}
